// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"857":"9fd88560","940":"b1063ebc"}[chunkId] + ".chunk.js";
};